import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, ReactiveFormsModule } from '@angular/forms';
import { TimePeriod, PeriodUnit } from 'src/app/api/api-campaigns.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
    selector: 'app-time-period-select',
    templateUrl: './time-period-select.component.html',
    styleUrls: ['./time-period-select.component.scss'],

    imports: [
        ReactiveFormsModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TimePeriodSelectComponent),
            multi: true
        }],

})
export class TimePeriodSelectComponent implements ControlValueAccessor {

  grp = new FormGroup({
    unit: new FormControl('', Validators.required),
    multiply: new FormControl('', Validators.required)
  });

  TimePeriodUnit = PeriodUnit;

  @Input('multiplyLabel') _multiplyLabel: string;

  constructor() { }

  /// ControlValueAccessor-------------------
  @Input('value') _value: any;
  onChange: any = () => { };
  onTouched: any = () => { };
  get value(): TimePeriod {
    return this._value;
  }
  set value(o: TimePeriod) {

    if (!o) return;

    this._value = o;

    this.grp.patchValue({
      unit: o.unit,
      multiply: o.multiply.toString()
    }, { emitEvent: false });

    this.onChange(o);
    this.onTouched();
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(_isDisabled: boolean): void {
  }
  /// ControlValueAccessor------------------

  notifyFormChanged() {
    this._value = this.getFormData();
    this.onChange(this._value);
    this.onTouched();
  }

  getFormData(): TimePeriod {
    const f: any = this.grp.value;

    if (!f.unit && !f.multiply)
      return undefined;

    return new TimePeriod({
      unit: f.unit,
      multiply: +f.multiply
    });
  }
}
